import classnames from "classnames";
import React from "react";

import useScrollDirection from "@hooks/useScrollDirection";
import ScrollDirectionContext from "@state/context/scroll/ScrollDirectionContext";
interface LayoutAppWrapperProps {
	children: React.ReactNode;
}

export function LayoutAppWrapper(props: LayoutAppWrapperProps) {
	const scrollDirection = useScrollDirection();

	const wrapperClassName = classnames("l--wrapper", `is-${scrollDirection}`);

	return (
		<ScrollDirectionContext.Provider value={scrollDirection}>
			<div className={wrapperClassName}>{props.children}</div>
		</ScrollDirectionContext.Provider>
	);
}

export default LayoutAppWrapper;
